var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[_c('label',{staticClass:"footer-text"},[_vm._v(_vm._s(_vm.previewText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }